import { useGLTF } from '@react-three/drei'
import { useMemo } from 'react'
import { useFrame } from '@react-three/fiber'
import { useControls } from 'leva'
import * as THREE from 'three'
import { useEffect } from 'react'
import holographicVertexShader from '../../shaders/holographic/vertex.glsl?raw'
import holographicFragmentShader from '../../shaders/holographic/fragment.glsl?raw'

const t = () => performance.now().toFixed(2)

const Track = (): React.JSX.Element => {

  const { scene } = useGLTF('/track-14.glb')

  const color = '#5a6af5'

  const material = useMemo(() => new THREE.ShaderMaterial({
    vertexShader: holographicVertexShader,
    fragmentShader: holographicFragmentShader,
    uniforms: {
      uTime: { value: 0 },
      uColor: { value: new THREE.Color(color).convertSRGBToLinear() },
    },
    transparent: true,
    side: THREE.DoubleSide,
    depthWrite: false,
    blending: THREE.AdditiveBlending,
  }), [])

  useFrame((state) => {
    material.uniforms.uTime.value = state.clock.getElapsedTime()
    material.uniforms.uColor.value.set(color).convertSRGBToLinear()
  })

  scene.traverse((child) => {
    if (child.isMesh) child.material = material
  })

  return <primitive object={scene} scale={0.1} />
}

export default Track